/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 * Extracted ability-template data (was part of Abilities.ts). Pure data; consumed by Abilities.
*/

export const weapons: Ability[] = [
		{
			name: "Battleaxe",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] slashing damage, or [STR 1D10] slashing damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Blowgun",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 25/100 ft., one target. *Hit:* [DEX 1] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Club",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D4] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			label: "Dagger (STR)",
			name: "Dagger",
			attribute: 'Strength',
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Dagger (DEX)",
			name: "Dagger",
			attribute: 'Dexterity',
			desc: "*Melee or Ranged Weapon Attack:* [DEX ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [DEX 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Dart (STR)",
			name: "Dart",
			attribute: 'Strength',
			desc: "*Ranged Weapon Attack:* [STR ATK] to hit, range 20/60 ft., one target. *Hit:* [STR 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Dart (DEX)",
			name: "Dart",
			attribute: 'Dexterity',
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 20/60 ft., one target. *Hit:* [DEX 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			name: "Flail",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Glaive",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D10] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Greataxe",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D12] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Greatclub",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Greatsword",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 2D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Halberd",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D10] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Handaxe",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Hand Crossbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 30/120 ft., one target. *Hit:* [DEX 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Heavy Crossbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 100/400 ft., one target. *Hit:* [DEX 1D10] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			name: "Javelin",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 30/120 ft., one target. *Hit:* [STR 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Lance",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D12] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Light Crossbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 80/320 ft., one target. *Hit:* [DEX 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			name: "Light Hammer",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D4] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Longbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 150/600 ft., one target. *Hit:* [DEX 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			name: "Longsword",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] slashing damage, or [STR 1D10] slashing damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Mace",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Maul",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 2D6] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Morningstar",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Net",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 5/15 ft., one Large or smaller creature. *Hit:* The target is restrained. A creature can use its action to make a DC 10 Strength check to free itself or another creature in a net, ending the effect on a success. Dealing 5 slashing damage to the net (AC 10) frees the target without harming it and destroys the net.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Pike",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D10] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Quarterstaff",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] bludgeoning damage, or [STR 1D8] bludgeoning damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			label: "Rapier (STR)",
			name: "Rapier",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Rapier (DEX)",
			name: "Rapier",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Scimitar (STR)",
			name: "Scimitar",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Scimitar (DEX)",
			name: "Scimitar",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX 1D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			name: "Shortbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 80/320 ft., one target. *Hit:* [DEX 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			label: "Shortsword (STR)",
			name: "Shortsword",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Shortsword (DEX)",
			name: "Shortsword",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			name: "Sickle",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D4] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Sling",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 30/120 ft., one target. *Hit:* [DEX 1D4] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Spear",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D6] piercing damage, or [STR 1D8] piercing damage if used with two hands to make a melee attack.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Trident",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D6] piercing damage, or [STR 1D8] piercing damage if used with two hands to make a melee attack.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'both',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Unarmed Strike",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Warhammer",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] bludgeoning damage, or [STR 1D10] bludgeoning damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "War Pick",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			label: "Whip (STR)",
			name: "Whip",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D4] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Whip (DEX)",
			name: "Whip",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 10 ft., one target. *Hit:* [DEX 1D4] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		}
	];
